import dashboard from './dashboard';
import pages from './page';
import utilities from './utilities';
import support from './support';
import datatable from './datatable';
import home from './home';
import portfolio from './portfolio';
import viewdata from './viewdata';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  // items: [dashboard, pages, utilities, datatable, support]
  items: [home]
};

//pages buat login dan register
//utilities buat design system
//dashboard buat dashboard utama
//datatable buat contoh table

export default menuItems;
